module.exports = __webpack_public_path__ + "static/media/3.e32996d1.jpg";